import { isPast, setHours, setMinutes } from 'date-fns'
import differenceInMinutes from 'date-fns/differenceInMinutes'
import moment from 'moment'
// import { useGetCategories } from 'src/hooks/useGetCategoriesV2'
import { getUser, hasRole } from './browser'
import { MAX_STUDENT_IN_CLASS_DEMO, USER_ROLES, USER_ROLES_ENUM } from './constant'
import { convertNumberToDate, currentDateWithTimezone, dateNumberAndStartTimeToDate, timeConvert, timeConvertHHmm } from './date'
import {
  getDateV2, hasIntersection, hasRequiredItem, isPastTime, isPastTimeV2, isPastTimeV3
} from './util'

export function classDemoHelper () {
  const user = getUser()
  const roles = [...user.userRoles]

  return {
    canFilterClassDemo: roles.some((item) =>
      [
        'admin', 'manager', 'employee-ministry', 
        'manager-monitor', 'employee-monitor', 'manager-teacher', 
        'employee-teacher', 'manager-sale', 'employee-sale', 'employee-customer-care-specialist'
      ].includes(item)
    ),

    canViewTicketFeedback: roles.some((item) =>
      [
        'admin',
        'manager',
        'manager-teacher',
        'employee-ministry',
        'employee-teacher',
        'manager-monitor',
        'manager-sale',
        'employee-sale',
        'employee-customer-care',
        'employee-collaborator-class'        
      ].includes(item)
    ),
  }
}

export function slotHelper (slot, monitorTicket, student) {
  // client side validate only
  if (!slot) return {}

  const isNotFull = !slot.numberOfStudents || (slot.maxStudentInClass ? slot.numberOfStudents < slot.maxStudentInClass : slot.numberOfStudents < MAX_STUDENT_IN_CLASS_DEMO)
  const isClassOnlyOneStudent = slot.maxStudentInClass ? Boolean(slot.maxStudentInClass === 1) : Boolean(MAX_STUDENT_IN_CLASS_DEMO === 1)
  const hasStudent = !!slot.numberOfStudents
  const isBooked = slot.status === 'BOOKED'
  const isOpen = slot.status === 'OPEN_FOLLOW_PLAN'
  const isPast = isSessionEnded(slot)

  const user = getUser()
  const roles = [...user.userRoles]

  const hasBigRoles = roles.some((item) =>
    ['admin', 'manager', 'employee-ministry', 'manager-monitor'].includes(item)
  )
  const hasMonitorManagerRole = roles.includes('manager-monitor')
  const hasMonitorEmployeeRole =
    roles.includes('employee-monitor') && !hasBigRoles
  const hasSaleEmployeeRole = roles.includes('employee-sale')
  const hasManagerSaleRole = roles.includes('manager-sale')
  const hasManagerTeacherRole = roles.includes('manager-teacher')
  const hasMonitorRoles = hasMonitorEmployeeRole || hasMonitorManagerRole
  const isOwnerMonitor =
    hasMonitorEmployeeRole &&
    (slot.monitorId?.toString() === user.userId?.toString() || monitorTicket?.userId?.toString() === user.userId?.toString())
  const isOwnerSale =
    hasSaleEmployeeRole && (!student || student?.saleId?.toString() === user.userId?.toString())
  return {
    isNotFull,
    hasStudent,
    isBooked,
    hasBigRoles,
    hasMonitorManagerRole,
    hasMonitorEmployeeRole,
    hasMonitorRoles,
    hasSaleEmployeeRole,
    hasManagerSaleRole,
    hasManagerTeacherRole,
    isPast,
    isEnded: isSessionEnded(slot),
    userId: user.userId,
    canCancelSlot: hasBigRoles && !hasStudent,
    canAddStudent: !isPast && (isBooked || isOpen) && isNotFull && (hasBigRoles || hasManagerSaleRole || hasSaleEmployeeRole || hasManagerTeacherRole),
    canRemoveStudent: !isPast && ((isOpen && hasStudent) || (isBooked && !isNotFull && !isClassOnlyOneStudent)) && (hasBigRoles || hasManagerSaleRole || (isOwnerSale) || isOwnerMonitor || hasManagerTeacherRole), // to view remove option on menu
    canCreateClassDemo: !isPast && hasStudent && isOpen && (hasBigRoles || hasMonitorEmployeeRole || hasManagerTeacherRole),
    canUpdateStudent: !isPast && (isOwnerMonitor || hasBigRoles || isOwnerSale || hasManagerTeacherRole)
  }
}

/**
 *  DEPRECATED - Không dùng
 * @param {*} param0
 * @returns
 */
export function canEditDemoClassStudentInfo (session, ticketMonitor) {
  if (!session) return false
  const isPast = isPastTime(session)
  const user = getUser()
  const roles = user.userRoles
  const hasBigRole = roles.some((role) =>
    ['admin', 'manager', 'manager-monitor', 'employee-ministry'].includes(role)
  )
  const isOwnerMonitor = ticketMonitor?.userId?.toString() === user.userId?.toString()
  return !isPast && (hasBigRole || isOwnerMonitor)
}
export function ticketMntrHelper (ticket, session, sessionTime) {
  if (!ticket) return {}
  const isPast = isPastTimeV2({ date: session?.learnDate, time: 1439 })

  const currentTime = currentDateWithTimezone()
  const sessionEndTime = getDateV2(session?.learnDate, timeConvertHHmm(sessionTime?.endTime))

  const isTicketClosed = differenceInMinutes(currentTime, sessionEndTime) >= 24 * 60
  const isTicketCanceled = ticket.status === 'CANCELED'
  const isTicketCompleted = ticket.status === 'DONE'
  const isTicketEnded = isTicketCompleted || isTicketCanceled
  const isTicketOpen = !ticket.userId && !isTicketEnded && !isPast

  const user = getUser()
  const roles = [...user.userRoles]
  const hasBigRoles = roles.some((role) => ['admin', 'manager'].includes(role))
  const hasManagerMonitorRole = roles.includes('manager-monitor')

  const hasViewOnlyRole = hasRequiredItem(roles, [
    'manager-teacher',
    'manager-sale',
    'employee-sale',
    'employee-customer-care',
    'employee-collaborator-class'
  ])
  const hasMonitorEmployeeRole = roles.includes('employee-monitor')
  const hasSaleEmployeeRole = roles.includes('employee-sale')
  const hasEmployeeCustomerCare = roles.includes('employee-customer-care')

  /**
  * isOwnerMonitor
  * Check điều kiện cho phép CTV trực lớp chỉ được xếp lớp 1 lần dựa theo trạng thái của ticket
  * >> user.userId: String
  * >> ticket.userId: Number
  * >> isTicketCompleted: check trạng thái của ticket đã hoàn thành hay chưa
  */
  const isOwnerMonitor =
  user.userId == ticket?.userId && roles.includes('employee-monitor')

  const canSelfAssignTicket =
    isTicketOpen &&
    (hasMonitorEmployeeRole || hasManagerMonitorRole || hasBigRoles)

  const canViewTicket =
    hasBigRoles ||
    hasManagerMonitorRole ||
    hasMonitorEmployeeRole ||
    hasSaleEmployeeRole ||
    hasEmployeeCustomerCare ||
    (hasViewOnlyRole && isTicketEnded)

  const canUpdateTicketBeforeClose =
    !hasBigRoles &&
    ((isOwnerMonitor && !isPast) || hasManagerMonitorRole) &&
    !isTicketClosed &&
    !isTicketCanceled

  const canUpdateTicket =
  (!isTicketCanceled && hasBigRoles) || (!isTicketCanceled && hasManagerMonitorRole) || canUpdateTicketBeforeClose

  return {
    isTicketEnded,
    canUpdateTicket,
    canUpdateTicketBeforeClose,
    canSelfAssignTicket,
    canViewTicket,
    canAddNoteStudent: canUpdateTicket || hasEmployeeCustomerCare,
    isSessionEnded: differenceInMinutes(currentTime, sessionEndTime) >= 0
  }
}
export function ticketKtHelper (ticket) {
  if (!ticket) return {}
  const isTicketEnded = ticket.status === 'DONE' || ticket.status === 'CANCELED'
  const isTicketOpen = !ticket.userId && !isTicketEnded
  const isTicketCanceled = ticket.status === 'CANCELED'
  const user = getUser()
  const roles = [...user.userRoles]
  const hasBigRoles = hasRequiredItem(roles, [
    'admin',
    'manager',
    'manager-monitor'
  ])
  const isTicketOwner = String(ticket.userId) === String(user.userId)
  const hasTechnicalEmployeeRole = roles.includes('employee-technical')
  const canSelfAssignTicketOnly =
    isTicketOpen && hasTechnicalEmployeeRole && !hasBigRoles
  const canEditTicket =
    (!isTicketEnded && !isTicketOpen && isTicketOwner) ||
    (!isTicketCanceled && hasBigRoles)
  const canCancelTicket = !isTicketEnded && hasBigRoles
  const canAssignTicket = canCancelTicket
  return {
    canSelfAssignTicketOnly,
    canEditTicket,
    canAssignTicket,
    canCancelTicket,
    canViewTicketDetail: true,
    isTicketEnded
  }
}

export function ticketFbhelper (ticket, TimeServer) {
  if (!ticket) return {}
  const { learnDate, classDemoTeacherId } = ticket
  const learnDateTimeClose = dateNumberAndStartTimeToDate({ date: learnDate, startTime: 1439 })
  const isTicketClosed = isPastTimeV3(learnDateTimeClose, TimeServer)
  const isTicketCanceled = ticket.status === 'CANCELED'
  const isTicketCompleted = ticket.status === 'DONE'
  const isTicketEnded = isTicketCompleted || isTicketCanceled

  const user = getUser()
  const roles = [...user.userRoles]
  const hasBigRoles = hasRequiredItem(roles, [
    'admin',
    'manager',
    'manager-teacher',
    'employee-ministry'
  ])
  const hasTeacherRole = roles.includes('employee-teacher')
  const isOwnerTeacher = user.userId?.toString() === classDemoTeacherId?.toString()
  const hasViewOnlyRole =
    !hasBigRoles &&
    !isOwnerTeacher &&
    hasRequiredItem(roles, [
      'manager-monitor',
      'manager-sale',
      'employee-sale',
      'employee-customer-care',
      'employee-collaborator-class'
    ])
  const canUpdateTicketBeforeClose =
    !hasBigRoles &&
    hasTeacherRole &&
    isOwnerTeacher &&
    !isTicketClosed &&
    !isTicketEnded

  return {
    hasTeacherRole,
    canCancelTicket: hasBigRoles && !isTicketCanceled && !isTicketEnded,
    canUpdateTicket:
      !isTicketCanceled && (hasBigRoles || canUpdateTicketBeforeClose),
    canUpdateTicketBeforeClose,
    isTicketEnded,
    canViewButton:
      isTicketCanceled ||
      canUpdateTicketBeforeClose ||
      (hasViewOnlyRole && isTicketCompleted),
    canViewMenu: (hasBigRoles || isOwnerTeacher) && !isTicketCanceled
  }
}

export function ticketPeriodicalhelper (ticket) {
  if (!ticket) return {}
  const user = getUser()
  const roles = [...user.userRoles]

  const isTicketCanceled = ticket.status === 'CANCELED'
  const isTicketCompleted = ticket.status === 'DONE'
  const isTicketEnded = isTicketCompleted || isTicketCanceled
  const isTicketOpen = !ticket.userId && !isTicketEnded
  const hasBigRoles = hasRequiredItem(roles, [
    'admin',
    'manager',
    'employee-ministry'
  ])
  const isOwner = user.userId === ticket.userId
  const hasCustomerCareEmployeeRole = roles.includes('employee-customer-care')
  const canSelfAssignTicketOnly =
    isTicketOpen && hasCustomerCareEmployeeRole && !hasBigRoles
  const canSelfEditTicket = !isTicketCanceled && !isTicketCompleted && isOwner
  return {
    canEditTicket:
      (!isTicketCanceled && hasBigRoles) || (!isTicketEnded && isOwner),
    canCancelTicket: !isTicketEnded && hasBigRoles,
    isTicketEnded,
    canSelfAssignTicketOnly,
    canSelfEditTicket
  }
}

export function ticketReportResultHelper (ticket) {
  if (!ticket) return {}
  const { learnDate, userId } = ticket
  const learnDateTimeClose = dateNumberAndStartTimeToDate({ date: learnDate, startTime: 1439 })
  const isTicketClosed = isPast(learnDateTimeClose)
  const isTicketCanceled = ticket.status === 'CANCELED'
  const isTicketCompleted = ticket.status === 'DONE'
  const isTicketEnded = isTicketCompleted || isTicketCanceled

  const user = getUser()
  const roles = [...user.userRoles]
  const hasBigRoles = hasRequiredItem(roles, [
    'admin',
    'manager',
    'manager-teacher',
    'employee-ministry'
  ])
  const hasTeacherRole = roles.includes('employee-teacher')
  const isOwnerTeacher = user.userId?.toString() === userId?.toString()
  const hasViewOnlyRole =
    !hasBigRoles &&
    !isOwnerTeacher &&
    hasRequiredItem(roles, [
      'manager-monitor',
      'manager-sale',
      'employee-sale',
      'employee-customer-care',
      'employee-collaborator-class'
    ])
  const canUpdateTicketBeforeClose =
    !hasBigRoles &&
    hasTeacherRole &&
    isOwnerTeacher &&
    !isTicketEnded &&
    !isTicketClosed

  return {
    hasTeacherRole,
    canCancelTicket: hasBigRoles && !isTicketCanceled && !isTicketEnded,
    canUpdateTicket:
      !isTicketCanceled && (hasBigRoles || canUpdateTicketBeforeClose),
    canUpdateTicketBeforeClose,
    isTicketEnded,
    isTicketClosed,
    canViewButton:
      isTicketCanceled ||
      canUpdateTicketBeforeClose ||
      (hasViewOnlyRole && isTicketCompleted),
    canViewMenu: hasBigRoles || isOwnerTeacher
  }
}

/**
 *  DEPRECATED - Không dùng
 */
export function teacherSessionHelper (session) {
  if (!session) {
    return {}
  }
  const isSessionEnded = isPastTime(session)
  const isSessionAssigned =
    session.status === 'ASSIGNED' || session.status === 'ASSIGNED_BACKUP'
  const isSessionOpen = session.status === 'OPEN'

  const user = getUser()
  const roles = [...user.userRoles]
  const hasBigRoles = roles.some((role) =>
    ['admin', 'manager', 'manager-teacher', 'employee-ministry'].includes(role)
  )
  const isOwnerTeacher = session?.teacherId === user.userId
  return {
    canConfirmOrDeclined:
      !isSessionEnded && isSessionAssigned && isOwnerTeacher,
    isBackupSession: session.status === 'ASSIGNED_BACKUP',
    canDeleteSession: !isSessionEnded && hasBigRoles && isSessionOpen,
    canRestoreSession:
      !isSessionEnded && session.status === 'CANCELED' && hasBigRoles
  }
}
export function pendingStudentHelper (arrangeDetail) {
  if (!arrangeDetail) {
    return {}
  }
  const user = getUser()
  const roles = [...user.userRoles]
  const hasBigRole = roles.some((role) =>
    ['admin', 'manager', 'employee-ministry'].includes(role)
  )

  const roleOnlyAssignCoor = roles.some((role) =>
    ['employee-customer-care'].includes(role)
  )

  const roleViewStudentScheduling = roles.some((role) =>
    ['employee-customer-care-specialist'].includes(role)
  )
  const canUpdateOrder =
    hasBigRole || roleViewStudentScheduling || String(arrangeDetail.userId) === String(user.userId)
  const canSchedule = canUpdateOrder && ['PROCESSING', 'OPEN', 'TODO'].includes(arrangeDetail.status)
  const canViewOnly =
    ((canUpdateOrder || roleViewStudentScheduling) && arrangeDetail.status === 'DONE') 
  return {
    canAssignCoor: hasBigRole || roleOnlyAssignCoor,
    canChangeCallStatus: canUpdateOrder,
    canUpdateOrder,
    canScheduleClass: canSchedule,
    canViewStudentSchedulingOnly: canViewOnly
  }
}
export function pendingMakeupHelper (arrangeDetail) {
  if (!arrangeDetail) {
    return {}
  }
  const user = getUser()
  const roles = [...user.userRoles]

  const roleAssignCoor = roles.some((role) =>
    ['admin', 'manager', 'employee-ministry', 'employee-collaborator-class'].includes(role)
  )

  const roleUpdateTicket = roles.some((role) =>
    ['admin', 'manager', 'employee-ministry', 'employee-collaborator-class', 'employee-customer-care-specialist'].includes(role)
  ) || String(arrangeDetail.userId) === String(user.userId)

  const roleScheduleClass = roleUpdateTicket && ['PROCESSING', 'OPEN', 'TODO'].includes(arrangeDetail.status)

  const roleOnlyViewDetail = (roles.some((role) =>
    ['admin', 'manager', 'employee-ministry', 'employee-collaborator-class', 'employee-customer-care-specialist'].includes(role)
  ) || String(arrangeDetail.userId) === String(user.userId)) && arrangeDetail.status === 'DONE'

  return {
    canAssignCoor: roleAssignCoor,
    canChangeCallStatus: roleUpdateTicket,
    canUpdateOrder: roleUpdateTicket,
    canScheduleClass: roleScheduleClass,
    canViewStudentSchedulingOnly: roleOnlyViewDetail
  }
}
export function pendingCareStudentHelper (arrangeDetail) {
  if (!arrangeDetail) {
    return {}
  }
  const user = getUser()
  const {status, doneDate, callStatus, careSpecialistId} = arrangeDetail || {}
  const currentTime = moment(new Date())
  const compareDate = moment(doneDate).add(1, 'days')
  const isLessThan24h = !doneDate || currentTime.isBefore(compareDate)

  const canUpdateCustomerCareSpecialist = hasRole([USER_ROLES_ENUM.ADMIN, USER_ROLES_ENUM.MANAGER])
  const canUpdateEmployeeCustomerCare = hasRole([USER_ROLES_ENUM.ADMIN, USER_ROLES_ENUM.MANAGER, USER_ROLES_ENUM.CUSTOMER_CARE_SPECIALIST])
  const canUpdateCallStatusAndMore = hasRole([USER_ROLES_ENUM.ADMIN, USER_ROLES_ENUM.MANAGER, USER_ROLES_ENUM.EMPLOYEE_MINISTRY, USER_ROLES_ENUM.EMPLOYEE_CUSTOMER_CARE, USER_ROLES_ENUM.CUSTOMER_CARE_SPECIALIST])
  const canAssignCoor = hasRole([USER_ROLES_ENUM.ADMIN, USER_ROLES_ENUM.MANAGER, USER_ROLES_ENUM.CUSTOMER_CARE_SPECIALIST])
  const canAssignCustomerCareSpecialist = hasRole([USER_ROLES_ENUM.ADMIN, USER_ROLES_ENUM.MANAGER])
  const canShowDetailCareStudent = status === 'SUCCESS' ||  status === 'FAILED' || status === 'TODO' || status === 'CANCELED'
  const canCareStudent = status === 'OPEN' ||  status === 'PROCESSING'
  const canUpdateCustomerCare = (isLessThan24h && hasRole([USER_ROLES_ENUM.CUSTOMER_CARE_SPECIALIST]) || canUpdateCustomerCareSpecialist) && status !== 'CANCELED'
  const canUpdateCallStatus = (isLessThan24h && hasRole([USER_ROLES_ENUM.CUSTOMER_CARE_SPECIALIST, USER_ROLES_ENUM.EMPLOYEE_CUSTOMER_CARE]) || canUpdateCustomerCareSpecialist) && status !== 'TODO' && status !== 'CANCELED' && callStatus !== "SUCCESSFUL_CONTACT"
  const disableUpdateWhenRoleCustomerCareSpecialist = hasRole([USER_ROLES_ENUM.CUSTOMER_CARE_SPECIALIST]) && user?.userId != careSpecialistId && !hasRole([USER_ROLES_ENUM.ADMIN, USER_ROLES_ENUM.MANAGER, USER_ROLES_ENUM.EMPLOYEE_MINISTRY])
  const disableCheckboxAssignSpecialist = status === 'SUCCESS' ||  status === 'FAILED' || status === 'CANCELED'
  return {
    canUpdateCustomerCareSpecialist,
    canUpdateEmployeeCustomerCare,
    canUpdateCallStatusAndMore,
    canAssignCustomerCareSpecialist,
    canShowDetailCareStudent,
    canCareStudent,
    canAssignCoor,
    canUpdateCallStatus,
    canUpdateCustomerCare,
    disableUpdateWhenRoleCustomerCareSpecialist,
    disableCheckboxAssignSpecialist
  }
}

export function demoClassHelper (classDemoData, timeSlot) {
  const isBooking = classDemoData?.status === 'BOOKED'
  const isClassDemoStarted = isPastTimeV2({ date: classDemoData?.learnDate, time: timeSlot?.startTime })

  const user = getUser()
  const isRoleValid = hasRequiredItem(user?.userRoles, ['admin', 'manager', 'manager-monitor'])
  
  const canCancelClassDemo = isBooking && !isClassDemoStarted && isRoleValid

  return {
    canCancelClassDemo
  }
}

export function regularClassHelper (classData) {
  if (!classData) return {}
  const isNormalActive = ['WAITING_FOR_START', 'ON_GOING'].includes(
    classData.status
  )
  const isActiveClass = isNormalActive
  const user = getUser()
  const roles = user.userRoles
  const hasRoleToUpdate = hasRequiredItem(roles, [
    'admin',
    'manager',
    'manager-monitor',
    'employee-ministry',
    'employee-collaborator-class',
    'manager-teacher',
    'employee-monitor',
    'employee-customer-care',
    'employee-customer-care-specialist'
  ])

  return {
    canCancelClass:
      isActiveClass &&
      hasRequiredItem(roles, ['admin', 'manager', 'employee-ministry', 'employee-customer-care-specialist']),
    canCancelStudentClass:
      isActiveClass && hasRequiredItem(roles, ['admin', 'manager', 'employee-customer-care-specialist']),
    canChangeStudentClass:
      isActiveClass &&
      hasRequiredItem(roles, [
        'admin',
        'manager',
        'employee-ministry',
        'employee-collaborator-class',
        'employee-customer-care-specialist'
      ]),
    canUpdateClassAndStudentDetail: isActiveClass && hasRoleToUpdate,
    canAddNote: hasRoleToUpdate, 
    hasRoleToUpdate,
    canAddSession:
      isNormalActive &&
      hasRequiredItem(roles, [
        'admin',
        'manager',
        'manager-monitor',
        'employee-ministry',
        'employee-monitor'
      ])
  }
}

export function studentCareHelper(taskDetail) {
  if (!taskDetail) {
    return {}
  }
  const user = getUser()
  const {status, doneDate, callStatus, careSpecialistId} = taskDetail || {}
  const currentTime = moment(new Date())
  const updateExpired = moment(doneDate).add(1, 'days')
  const isLessThan24h = !doneDate || currentTime.isBefore(updateExpired)

  const hasBigRoles = hasRole([USER_ROLES_ENUM.ADMIN, USER_ROLES_ENUM.MANAGER, USER_ROLES_ENUM.EMPLOYEE_MINISTRY])
  const isCareTeacherValid = user?.userId?.toString() === careSpecialistId?.toString() && hasRole([USER_ROLES_ENUM.CUSTOMER_CARE_SPECIALIST]) && !hasBigRoles

  const canMassAssignTicket = ['OPEN', 'PROCESSING'].includes(status) && hasBigRoles
  const canUpdateCallStatus = ['OPEN', 'PROCESSING'].includes(status) ? (isCareTeacherValid || hasBigRoles) : ['SUCCESS'].includes(status) ? ((isLessThan24h && isCareTeacherValid) || hasBigRoles) : false
  const canViewDetail = hasBigRoles || isCareTeacherValid

  return {
    canMassAssignTicket,
    canUpdateCallStatus,
    canViewDetail
  }
}

/**
 *
 * @param {Object} session - Data buổi học trả về từ backend
 * @param {Object} timeSlot - Data khung giờ dạy được lấy trong mảng times slot config
 * @returns {Object}
 */
export function regularSessionHelper (session, timeSlot) {
  if (!session) return {}
  const isBooking = session.status === 'BOOKED' || session.status === 'OPEN'
  const isSessionStarted = isPastTimeV2({ date: session.learnDate, time: timeSlot?.endTime })

  const user = getUser()
  const roles = user.userRoles
  const hasRoleToAssignMonitor = hasRequiredItem(roles, [
    'admin',
    'manager',
    'manager-monitor',
    'employee-ministry',
    'employee-collaborator-class',
    'manager-teacher',
    'employee-customer-care-specialist'
  ])
  const hasRoleToAssignAdminMinistry = hasRequiredItem(roles, [
    'admin',
    'employee-ministry',
    'employee-customer-care-specialist'
  ])
  const hasRoleToWeekStudying = hasRequiredItem(roles, [
    'admin',
    'manager',
    'employee-ministry',
    'employee-collaborator-class',
    'employee-customer-care-specialist'
  ])
  return {
    isMakupSession: session.sessionType === 'MAKE_UP_LESSON',
    isSessionStarted,
    hasRoleToAssignMonitor,
    hasRoleToAssignAdminMinistry,
    hasRoleToWeekStudying,
    canEditSession:
      !isSessionStarted &&
      isBooking &&
      (hasRoleToAssignMonitor || roles.includes('employee-monitor'))
  }
}

export function canAssignTeacherOrMonitor (session) {
  if (!session) return {}
  const { monitorId, endTime, learnDate } = session
  const isEnded = isSessionEnded(session)
  const isBooking = session.status === 'BOOKED'
  const user = getUser()
  const roles = user.userRoles
  const hasRequiredRole = roles.some((role) =>
    ['admin', 'manager', 'manager-monitor', 'employee-ministry', 'manager-teacher'].includes(role)
  )
  const isOwnerMonitor =
    !hasRequiredRole &&
    roles.includes('employee-monitor') &&
    session && monitorId?.toString() === user.userId?.toString()
  return {
    canAssignMonitor: !isEndTimeSession(learnDate, endTime) && hasRequiredRole && isBooking,
    canAssignTeacher:
      !isEndTimeSession(learnDate, endTime) && isBooking && (hasRequiredRole || isOwnerMonitor)
  }
}

export function canAssignTicket () {
  const user = getUser()
  const roles = user?.userRoles || []
  return hasIntersection(roles, [
    'admin',
    'manager',
    'manager-monitor'
  ])
}

export function getRoleOptionsBasedOnRole () {
  // to create or edit user
  const userRoles = getUser().userRoles
  let selectedRoles = []
  if (hasRequiredItem(userRoles, ['admin'])) {
    return USER_ROLES
  } else if (hasRequiredItem(userRoles, ['manager'])) {
    return USER_ROLES.slice(1)
  } else {
    if (hasRequiredItem(userRoles, ['manager-monitor'])) {
      selectedRoles = selectedRoles.concat([
        'employee-monitor',
        'employee-technical'
      ])
    }
    if (hasRequiredItem(userRoles, ['employee-ministry'])) {
      selectedRoles = selectedRoles.concat([
        'employee-customer-care',
        'employee-collaborator-class'
      ])
    }
    if (hasRequiredItem(userRoles, ['manager-sale'])) {
      selectedRoles = selectedRoles.concat(['employee-sale'])
    }
    if (hasRequiredItem(userRoles, ['manager-teacher'])) {
      selectedRoles = selectedRoles.concat(['employee-teacher'])
    }
  }
  return selectedRoles
}

function isSessionEnded (session) {
  const { learnDate, startTime } = session
  const startTimeByTime = dateNumberAndStartTimeToDate({ date: learnDate, startTime })
  return isPast(startTimeByTime)
}

function isEndTimeSession (date, time) {
  let dateType = convertNumberToDate(date)
  const { hours, minutes } = timeConvert(time)
  dateType = setHours(dateType, hours)
  dateType = setMinutes(dateType, minutes)
  return isPast(dateType)
}
